import {
  Toaster as SonnerToaster,
  ToasterProps as SonnerToasterProps,
} from 'sonner';
import { ThemeProvider, useTheme, type ThemeNames } from '../../../../theme';
import { JSX } from 'react';

export type ToasterProps = {
  themeName: ThemeNames;
  offset: SonnerToasterProps['offset'];
  mobileOffset: SonnerToasterProps['mobileOffset'];
};

export const TOASTER_PADDING_OFFSET = 36; // theme.spacing(4) (CallLayout padding) + theme.spacing(4) (Toaster offset)

export const Toaster = ({
  themeName,
  offset,
  mobileOffset,
}: ToasterProps): JSX.Element => {
  const theme = useTheme(themeName);

  const options: SonnerToasterProps = {
    position: 'bottom-right',
    duration: 10_000,
    offset,
    mobileOffset,
    visibleToasts: 5,
    swipeDirections: ['right'],
    gap: 8, // theme.spacing(2)
    style: {
      zIndex: theme.zIndex.toasts,
      transition: theme.transitions.create('bottom', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toastOptions: {
      style: {
        overflow: 'hidden',
        boxShadow: theme.shadows[4],
        borderRadius: theme.shape.radius8,
      },
    },
  };

  return (
    <ThemeProvider themeName={themeName}>
      <SonnerToaster {...options} />
    </ThemeProvider>
  );
};
